import React from "react";
import { FormGroup } from "reactstrap";
import Vacante from "../components/Vacante";
import { getSolicitudes } from "../requests/req_postulaciones";
import CardPostulacion from "../components/CardPostulacion";

export default class Postulaciones extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showOffer: false,
      vacantes: null,
      idVacante: null,
      moduloModal: null,
      datos_post: null
    };
    this.ocultaOferta = this.ocultaOferta.bind(this);
    this.mostrarOferta = this.mostrarOferta.bind(this);
    this.generaTarjetas = this.generaTarjetas.bind(this);
    this.obtienePostulaciones = this.obtienePostulaciones.bind(this);
    this.estableceSolicitudes = this.estableceSolicitudes.bind(this);
    this.resetCards = this.resetCards.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    getSolicitudes((e) => this.estableceSolicitudes(e));
  }
  resetCards() {

    getSolicitudes((e) => this.estableceSolicitudes(e));
  }
  estableceSolicitudes(datos) {
    if (datos != null)
      this.setState({ datos_post: datos, vacantes: datos });
  }
  //Ocultar detalle de la oferta
  ocultaOferta(datoHijo) {
    this.setState({ showOffer: datoHijo });
  }

  //función que obtiene postulaciones de la BD
  obtienePostulaciones() {
    if (this.state.datos_post !== null) {
      var d = this.state.datos_post;
      return (
        <FormGroup className="ARC_Prfl_Pstl" row>
          {this.generaTarjetas(d)}
        </FormGroup>
      );

    }
  }

  //Mostrar detalle de la oferta
  mostrarOferta(e) {
    this.setState({
      showOffer: true,
      idVacante: e
    });
  }

  //Función que genera las tarjetas de las postulaciones
  generaTarjetas(datos) {
    if (!datos) return null;
    return datos.map((a, index) => {
      return (
        <CardPostulacion data={a} key={index} action={this.mostrarOferta} reset={this.resetCards} />
      );
    });
  }
  render() {
    return (
      <div className="ARC_Perfil">
        <Vacante
          mostrar={this.state.showOffer}
          action={this.ocultaOferta}
          vacantes={this.state.vacantes}
          idvac={this.state.idVacante}
        />
        {this.obtienePostulaciones()}
        <button id="btnresetPost" type='button' hidden={true} onClick={e => this.resetCards()}></button>
      </div>
    );
  }
}
